const TARGET = 'dashboard';

const initialState = {
  data: null,
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case 'API_CALL_REQUEST':
      if(action.target !== TARGET) return state;
      return {
        data: null,
        loading: true,
        error: false,
      };
    case 'API_CALL_COMPLETE':
      if(!action.response || action.response.target !== TARGET) return state;
      return {
        data: action.response.result,
        loading: false,
        error: false,
      };
    case 'API_CALL_FAILED':
      if(!action.request || action.request.target !== TARGET) return state;
      return {
        data: null,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export {
  reducer as dashboard,
};
